<nz-tree-select [nzDropdownStyle]="{ 'max-height': '300px' }"
[nzShowSearch]="nzShowSearch" [(ngModel)]="Param" 
[nzCheckable]="nzCheckable" [nzCheckStrictly]="nzCheckStrictly" 
 [nzMaxTagPlaceholder]="omittedPlaceHolder" 
[nzNodes]="nodes" [nzDefaultExpandAll]="nzDefaultExpandAll" 
[nzAllowClear]="false" (ngModelChange)="onChange($event)">
</nz-tree-select>
<ng-template #omittedPlaceHolder let-omittedValues> and {{ omittedValues.length }} more... </ng-template>